import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardFooter,
  UncontrolledDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
  Tooltip,
  Modal,
  ModalBody,
} from "reactstrap";
import {
  Container,
  Row,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { useParams, useLocation } from "react-router-dom";
import { Field, Formik } from "formik";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import FormikSelectField from "components/common/Fields/FormikSelectField";

import moment from "moment";

// import { Field, Formik } from 'formik';
import HoverImage from "react-hover-image/build";
import { cellRendererCheck, dateFormate } from "utils/columns";
import filter from "assets/icon/filter-icon.svg";
import SortArrow from "assets/icon/sort-arrow.svg";
import Plus from "assets/icon/plus-rx.svg";
import Calendar from "assets/icon/calendar-pms.svg";
import admin from "assets/icon/admin-black.svg";
// import Cal from "assets/icon/calendar-pms.svg";
import leftArrow from "assets/icon/left-arrow.svg";
import ScanIcon from "assets/icon/scan-icon.svg";
import drug from "assets/icon/drug-status.svg";
import drugList from "assets/icon/drug-list.svg";
import threeDotsIcon from "assets/icon/3-dots.svg";
import closeIcon from "assets/icon/close-icon.svg";
import { useNavigate } from "react-router-dom";
import DrugUtilPopUp from "pages/OrderEntry/DrugUtilPopUp";
import Drawer from "components/Drawer";
import ClaimsInfo from "pages/OrderEntry/ClaimsInfo";
import plusIcon from "assets/icon/plus-icon-add-note.svg";
import uploadIcon from "assets/icon/upload-icon.svg";
import drugPurpleIcon from "assets/icon/drug-status.svg";
import drugLightIcon from "assets/icon/drug-with-reddot.svg";
import drugWhite from "assets/icon/druglist-green.svg";
import searchIcon from "assets/icon/search.svg";
import searchGrayIcon from "assets/icon/search-inactive.svg";
import patientsScanImage from "assets/images/patients-scan.svg";
import ZoomInIcon from "assets/icon/zoom-in-icon.svg";
import ZoomOutIcon from "assets/icon/zoom-out-icon.svg";
import DeleteIcon from "assets/icon/delete-icon.svg";
import PatientsDemographic from "components/PatientsDemographic";
import ReactInputMask from "react-input-mask";
import SearchContainer from "pages/OrderEntry/SearchContainer/Index";
import Confirm from "components/Confirm";
import PrescriptionSummary from "components/PrescriptionSummary";
import Stepper from "react-stepper-horizontal";
import purpleCrossIcon from "../../../assets/icon/purple-cross-icon.svg";
import statusPurple from "../../../assets/icon/status-save-icon.svg";
import MessageIconDark from "../../../assets/icon/messageIcon-dark.svg";
import MessageIconLight from "../../../assets/icon/messageIcon-light.svg";
import completeIcon from "../../../assets/icon/complete.svg";
import orderDetailsIcon from "../../../assets/icon/order-details-icon.svg";
import SearchContainerOrderEntry from "components/SearchContainerOrderEntry";
import resetBtnIcon from "../../../assets/icon/reset-btn-icon.svg";
import saveBtnIcon from "../../../assets/icon/cancel-icon-circle.svg";
import submitBtnIcon from "../../../assets/icon/submit-btn-icon.svg";
import patientProfile from "../../../assets/icon/patient-profile.svg";
import rxHistory from "../../../assets/icon/rx-history-icon.svg";
import upArrow from "../../../assets/inventory/up-arrow.svg";
import downArrow from "../../../assets/inventory/down-arrow.svg";
// import PatientsDemo from "components/PatientDemo/Index";
import plusPurple from "../../../assets/icon/plus-icon-add-note.svg";
import plusIcons from "../../../assets/icon/plus-icon.svg";
import dubbleArrow from "../../../assets/icon/double-arrow-down-purple.svg";
import eidtPurpleIcon from "../../../assets/icon/eidtPurpleIcon.svg";
import deleteIcon from "../../../assets/icon/delete-white-icon.svg";
import Chating from "pages/OrderEntry/Chating";
import { address } from "@withshepherd/faker";

const InitialPatientEditDetails = () => {
  const navigate = useNavigate();
  const [drugUtil, setDrugUtil] = useState(false);
  const [claimsInfo, setClaimsInfo] = useState(false);
  const [msgInfo, setMsgInfo] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [endDate, setEndDate] = useState(new Date());
  const [startDate, setStartdate] = useState(new Date());
  const [focusedInput, setFocusedInput] = useState("");
  const [open, setOpen] = useState("1");
  const [openPatinetsDetails, setOpenPatinetsDetails] = useState("10");
  const [loading, setLoading] = useState(false);
  const [searchTermDrug, setSearchTermDrug] = useState("");

  const initialImage = patientsScanImage;
  const [openStatus, setOpenStatus] = useState(false);
  const [searchTermPrescriber, setSearchTermPrescriber] = useState({
    medication: "Venlafaxine ER Tablet 150MG",
    prescriber: "ROBERT SMITH, MD",
    dignosis: "",
  });
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState("");
  const [openOne, setOpenOne] = useState("1");
  const [openTwo, setOpenTwo] = useState("1");
  const [openThree, setOpenThree] = useState("1");
  const [directions, setDirections] = useState("Take 1 Tablet By Mouth Daily");
  const [quantity, setQuantity] = useState("30");
  const [daySupply, setDaySupply] = useState("30");
  const [refills, setRefills] = useState("5");

  const [selectedOptions, setSelectedOptions] = useState({
    option1: "",
    option2: "",
  });
  const [increment, setIncrement] = useState({
    totalQtyWritten: 0,
    serialNo: 0,
    partialFillQty: 0,
  });

  const currentStep = 3;
  const location = useLocation();
  const rowData = location.state;

  const namesData = {
    fullName: "John Doe",
    firstName: "John",
    lastName: "Doe",
    phone: "(555) 123-4567",
    dob: "01/08/1996 (28 Years)",
    address: "123, Main ST, Anytown, USA, 12345",
  };
  const handleChangeOption = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prevOptions) => ({
      ...prevOptions,
      [name]: value,
    }));
  };

  const togglebtnOne = (id) => {
    if (openOne === id) {
      setOpenOne();
    } else {
      setOpenOne(id);
    }
  };
  const togglebtnTwo = (id) => {
    if (openTwo === id) {
      setOpenTwo();
    } else {
      setOpenTwo(id);
    }
  };
  const togglebtnThree = (id) => {
    if (openThree === id) {
      setOpenThree();
    } else {
      setOpenThree(id);
    }
  };

  const handleChangeDirections = (e) => {
    setDirections(e.target.value);
  };

  // Clear individual fields
  const clearSearch = (field) => {
    setSearchTermPrescriber((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleInputChangePrescriber = (e) => {
    const { name, value } = e.target;
    setSearchTermPrescriber((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const clearSearchPrescriber = () => {
    setSearchTermDrug("");
  };
  const handleChangeIncrement = (e) => {
    const { name, value } = e.target;
    setIncrement((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleIncrement = () => {
    setIncrement((prevState) => ({
      ...prevState,
      totalQtyWritten: prevState.totalQtyWritten + 1,
    }));
  };
  const handleDecrement = () => {
    if (increment.totalQtyWritten > 0) {
      setIncrement((prevState) => ({
        ...prevState,
        totalQtyWritten: prevState.totalQtyWritten - 1,
      }));
    }
  };
  const handleAddTask = () => {
    if (newTask.trim() === "") return;
    setTasks([...tasks, { task: newTask, completed: false }]);
    setNewTask("");
  };

  const toggleTaskCompletion = (index) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].completed = !updatedTasks[index].completed;
    setTasks(updatedTasks);
  };

  const handleDeleteTask = (index) => {
    const updatedTasks = tasks.filter((_, idx) => idx !== index);
    setTasks(updatedTasks);
  };
  const handleChangePath = () => {
    navigate("/workflow-orderEntry");
  };

  const patientDetails = [
    {
      name: "John, David",
      dob: "01/08/1996",
      phone: "(555) 123-4567",
      prescriberName: "Smith, Robert",
      officeAddess: "1234cMaple Rd,Anytown,USA",
      officePhone: "(555) 123-4567",
      medication: "Venlafaxine ER Tablet 150MG",
      daw: "0-Not specified",
      quantity: "30 EA",
      direction: "Take 1 tablet by mouth",
      refills: "05",
      dateWritten: "12/19/2024",
      notes: "Please contact the office to report any insurance issues",
      signature: "Robert Smith.MD at 12/19/2024, 1:02 PM EST",
    },
  ];


  const togglebtn = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  const handleClickStatus = () => {
    setOpenStatus((prevState) => !prevState);
  };
  const togglePatientDetails = (id) => {
    if (openPatinetsDetails === id) {
      setOpenPatinetsDetails();
    } else {
      setOpenPatinetsDetails(id);
    }
  };
  const goBack = () => {
    navigate(-1);
    // setConfirm(true);
  };
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleInputChange = (e) => {
    setSearchTermDrug(e.target.value);
  };

  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleBlur = () => {
    setFocusedInput("");
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setStartdate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setStartdate(null);
      setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };
  const handleEndDate = (endDate) => {
    if (startDate !== null) {
      const date = moment(endDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setEndDate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setEndDate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleEndDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && endDate !== null) {
      setEndDate(null);
      setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleEndDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };
  const stepNum = 2;
  const numSteps = 9;
  const step = [
    { title: "Patient", time: "13:21", date: "02/06/2025" },
    { title: "Patient", time: "13:21", date: "02/06/2025" },
  ];

  return (
    <>
      <Container fluid className="initial-details-body p-3 pt-0">
        <Container fluid>
          <PatientsDemographic
            fullName={rowData.patient}
            firstName={rowData.patient.split(",")[0].trim()}
            lastName={rowData.patient.split(" ")[1]?.trim()}
            dob={namesData.dob}
            phone={namesData.phone}
          />
          <Container fluid className="logo-drawer mb-8">
            <Row>
              <Col className="d-flex justify-content-start gap-2">
                <div
                  style={{ opacity: !drugUtil ? "0.4" : "" }}
                  onClick={drugUtil ? () => setDrugUtil(true) : null}
                  id="ScheduleUpdateTooltip"
                >
                  <HoverImage
                    className="drug-status"
                    src={drugPurpleIcon}
                    hoverSrc={drugLightIcon}
                    alt=""
                  />
                  <UncontrolledTooltip
                    disabled
                    placement="bottom"
                    target="ScheduleUpdateTooltip"
                    trigger="hover"
                  >
                    Drug Utilization Review
                  </UncontrolledTooltip>
                </div>
                <div
                  style={{ opacity: !claimsInfo ? "0.4" : "" }}
                  onClick={claimsInfo ? () => setClaimsInfo(true) : null}
                  id="ScheduleUpdateTooltip2"
                >
                  <HoverImage
                    className="drug-status"
                    src={drugList}
                    hoverSrc={drugWhite}
                    alt=""
                  />
                  <UncontrolledTooltip
                    // className="tooltip-custom"
                    style={{ position: "relative", left: "30px" }}
                    placement="bottom"
                    target="ScheduleUpdateTooltip2"
                    trigger="hover"
                  >
                    Claims Information
                  </UncontrolledTooltip>
                </div>
                <div
                  // className="drug-status"
                  onClick={() => setMsgInfo(!msgInfo)}
                  id="ScheduleUpdateTooltip3"
                >
                  <HoverImage
                    src={MessageIconDark}
                    className="drug-status"
                    hoverSrc={MessageIconLight}
                    alt=""
                  />
                  <UncontrolledTooltip
                    // className="tooltip-custom"
                    style={{ position: "relative", left: "30px" }}
                    placement="bottom"
                    target="ScheduleUpdateTooltip3"
                    trigger="hover"
                  >
                    Comments
                  </UncontrolledTooltip>
                </div>
                <div className="comment">
                  <img src={completeIcon} alt="not available" />
                  340B Eligible
                </div>
              </Col>
              <Col className="d-flex justify-content-end">
                <Button color="primary" className="reset">
                  <img src={patientProfile} />
                  Patient Profile
                </Button>
                <Button className="back-button primary">
                  {" "}
                  <img src={rxHistory} />
                  Rx History
                </Button>
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={() => setDropdownOpen(!dropdownOpen)}
                  style={{ marginLeft: "12px" }}
                >
                  <DropdownToggle color="primary" className="togglebtn">
                    {dropdownOpen ? (
                      <img src={closeIcon} alt="icon" />
                    ) : (
                      <img src={threeDotsIcon} alt="icon" />
                    )}
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem className="dropdownitem-border">
                      <img src={plusIcon} /> Add Notes
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Print
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> E-Rx Details{" "}
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Forward Rx
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Due
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> P/A
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Rx History
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>
          </Container>
          <div className="initial-edit-accordian-div">
            <Accordion open={openOne} toggle={togglebtnOne} className="mb-2">
              <AccordionItem>
                <AccordionHeader targetId="1">Order Details</AccordionHeader>
                <AccordionBody accordionId="1" style={{ marginLeft: "16px" }}>
                  <Row>
                    <Col>
                      <div className="final-acc-header">New E-Prescription</div>
                    </Col>
                    <Col>
                      <div className="final-acc-header">Order Entry</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={6}
                      sm={12}
                      style={{
                        backgroundColor: "#F7F7F7",
                        borderTop: "1px solid #d3d3d3",
                      }}
                    >
                      <Row
                        style={{
                          paddingTop: "12px",
                        }}
                      >
                        <Col lg={5} className="final-review-key">
                          Patient Name :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          Doe, John
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Birth Date :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          01/08/1996
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Phone :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          (555) 978-6543
                        </Col>
                      </Row>
                      <Row className="final-e-summary"></Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Prescriber Name :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          Smith, Robert
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Office Address :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          1234 Maple Rd, Anytown, USA
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Office Phone :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          (555) 978-6543
                        </Col>
                      </Row>
                      <Row className="final-e-summary"></Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Medication :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          Venlafaxine ER Tablet 150MG
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          DAW :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          0-Not Specified
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Quantity :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          30 EA
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Directions :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          Take 1 Tablet by Mouth Daily
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Refills :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          5
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Electronic Signature :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          Robert Smith. MD at 12/19/2024, 1:02 EST.
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} className="final-review-key">
                          Note :{" "}
                        </Col>
                        <Col lg={7} className="final-review-value">
                          Please contact the office to report any insurance
                          issues
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      style={{
                        paddingLeft: "20px",
                      }}
                      md={6}
                      sm={12}
                    >
                      <Row style={{ borderTop: "1px solid #d3d3d3" }}>
                        <Col sm={12} md={6} className="required-date ">
                          <Label className="order-entry-details">
                            Date Written
                          </Label>
                          <InputGroup
                            onMouseLeave={handleMouseLeave}
                            className="date-14px"
                          >
                            <DatePicker
                              id="startDate"
                              name="startDate"
                              selected={startDate}
                              onChange={(startDate) =>
                                handleStartDate(startDate)
                              }
                              onFocus={() => handleFocus("StartDate")}
                              onBlur={handleBlur}
                              isClearable
                              onChangeRaw={handleStartDateRaw}
                              dateFormat="MM/dd/yyyy"
                              placeholderText="MM/DD/YYYY"
                              autoComplete="off"
                              customInput={
                                <ReactInputMask
                                  mask="99/99/9999"
                                  value={startDate}
                                />
                              }
                            />
                            <InputGroupText
                              onClick={() => handleDateClick("startDate")}
                            >
                              <img src={Calendar} alt="" />
                            </InputGroupText>
                          </InputGroup>
                        </Col>
                        <Col sm={12} md={6} className="required-date ">
                          <Label className="order-entry-details">
                            Dispense Date
                          </Label>
                          <InputGroup
                            onMouseLeave={handleMouseLeave}
                            className="date-14px"
                          >
                            <DatePicker
                              id="endDate"
                              name="endDate"
                              selected={endDate}
                              onChange={(endDate) => handleEndDate(endDate)}
                              onFocus={() => handleFocus("endDate")}
                              onBlur={handleBlur}
                              isClearable
                              onChangeRaw={handleEndDateRaw}
                              dateFormat="MM/dd/yyyy"
                              placeholderText="MM/DD/YYYY"
                              autoComplete="off"
                              customInput={
                                <ReactInputMask
                                  mask="99/99/9999"
                                  value={endDate}
                                />
                              }
                            />
                            <InputGroupText
                              onClick={() => handleDateClick("endDate")}
                            >
                              <img src={Calendar} alt="" />
                            </InputGroupText>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row>
                        <FormGroup className="controls textarea_info search-flex mb-0">
                          <Label className="order-entry-details">
                            Medication
                          </Label>
                          <InputGroup>
                            <Input
                              // className="required"
                              type="text"
                              name="medication"
                              value={searchTermPrescriber.medication}
                              onChange={handleInputChangePrescriber}
                              placeholder="Search by Prescriber Name"
                            />
                            {searchTermPrescriber.medication ? (
                              <button
                                onClick={() => clearSearch("medication")}
                                className="clearButton"
                              >
                                &#x2715; {/* Unicode for the "x" symbol */}
                              </button>
                            ) : (
                              <img src={searchGrayIcon} />
                            )}
                          </InputGroup>
                        </FormGroup>
                      </Row>
                      <Row>
                        <FormGroup className="controls textarea_info search-flex mb-0">
                          <Label className="order-entry-details">
                            Prescriber
                          </Label>
                          <InputGroup>
                            <Input
                              // className="required"
                              type="text"
                              name="prescriber"
                              value={searchTermPrescriber.prescriber}
                              onChange={handleInputChangePrescriber}
                              placeholder="Search by Product Name"
                            />
                            {searchTermPrescriber.prescriber ? (
                              <button
                                onClick={() => clearSearch("prescriber")}
                                className="clearButton"
                              >
                                &#x2715; {/* Unicode for the "x" symbol */}
                              </button>
                            ) : (
                              <img src={searchGrayIcon} />
                            )}
                          </InputGroup>
                        </FormGroup>
                      </Row>
                      <Row>
                        <FormGroup className="controls mb-0">
                          <Label className="order-entry-details">
                            Directions
                          </Label>
                          <Input
                            style={{ border: "1px soild" }}
                            className="textlength"
                            name="directions"
                            type="textarea"
                            value={directions}
                            onChange={handleChangeDirections}
                            placeholder="Enter Directions"
                          />
                        </FormGroup>
                      </Row>
                      <Row>
                        <Col sm={12} md={4}>
                          <FormGroup className="controls textarea_info search-flex mb-0 ">
                            <Label className="order-entry-details">
                              Quantity
                            </Label>
                            <InputGroup>
                              <Input
                                setcss="required"
                                type="number"
                                value={quantity}
                                onChange={(e) => setQuantity(e.target.value)}
                                autoComplete="off"
                                placeholder="30"
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                        <Col sm={12} md={4}>
                          <FormGroup className="controls textarea_info search-flex mb-0">
                            <Label className="order-entry-details">
                              Days Supply
                            </Label>
                            <InputGroup>
                              <Input
                                setcss="required"
                                type="number"
                                autoComplete="off"
                                placeholder="5"
                                value={daySupply}
                                onChange={(e) => setDaySupply(e.target.value)}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                        <Col sm={12} md={4}>
                          <FormGroup className="controls textarea_info search-flex mb-0">
                            <Label className="order-entry-details">
                              Refill
                            </Label>
                            <InputGroup>
                              <Input
                                setcss="required"
                                type="number"
                                autoComplete="off"
                                placeholder="0"
                                value={refills}
                                onChange={(e) => setRefills(e.target.value)}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
            <Accordion open={false} toggle={togglebtnTwo} className="mb-2">
              <AccordionItem>
                <AccordionHeader targetId="1">
                  Payment / Insurance Details
                </AccordionHeader>
                <AccordionBody accordionId="1" style={{ marginLeft: "16px" }}>
                  <Row>
                    <Col>
                      <div className="final-acc-header">New E-Prescription</div>
                    </Col>
                    <Col>
                      <div className="final-acc-header">Order Entry</div>
                    </Col>
                  </Row>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
            <Accordion open={false} toggle={togglebtnThree} className="mb-2">
              <AccordionItem>
                <AccordionHeader targetId="1">Other Details</AccordionHeader>
                <AccordionBody
                  accordionId="1"
                  style={{ marginLeft: "16px" }}
                ></AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>
        </Container>
        <Container fluid>
          <Row>
            <div className="initial-edit-main-footer">
              <div>
                <Button color="primary" className="reset">
                  <img src={resetBtnIcon} />
                  Reset
                </Button>
              </div>
              <div className="initial-edit-footer">
                <Button className="back-button">
                  <img src={saveBtnIcon} />
                  Cancel
                </Button>

                <Button
                  color="primary"
                  className="submit"
                  onClick={() => setDrugUtil(true)}
                >
                  <img src={submitBtnIcon} /> Save Changes
                </Button>
              </div>
            </div>
          </Row>
        </Container>
      </Container>
      <div>
        <Drawer
          direction="end"
          size="lg"
          isOpen={drugUtil}
          toggle={() => setDrugUtil(!drugUtil)}
          title="Drug Utilization Review"
        >
          <DrugUtilPopUp openCliams={setClaimsInfo} />
        </Drawer>
        <Drawer
          direction="end"
          size="lg"
          isOpen={claimsInfo}
          toggle={() => setClaimsInfo(!claimsInfo)}
          title="Claims Information"
        >
          <ClaimsInfo gotoMainPath={handleChangePath} />
        </Drawer>
        <Drawer
          direction="end"
          size="lg"
          isOpen={msgInfo}
          toggle={() => setMsgInfo(!msgInfo)}
          title="Chat"
        >
          <Chating />
        </Drawer>
      </div>
    </>
  );
};
export default InitialPatientEditDetails;
